import React from 'react';
import { Award, Hammer, Clock, DollarSign, CheckCircle2, Shield } from 'lucide-react';
import { whyChooseUs } from '../mock';

const iconMap = {
  Award,
  Hammer,
  Clock,
  DollarSign,
  CheckCircle2,
  Shield
};

const WhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Us
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            We're committed to delivering excellence in every project. Here's what sets us apart
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((feature) => {
            const Icon = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group p-8 bg-gray-50 rounded-sm hover:bg-amber-50 transition-all duration-300 hover:shadow-lg border border-transparent hover:border-amber-200"
              >
                <div className="w-14 h-14 bg-amber-100 rounded-sm flex items-center justify-center mb-6 group-hover:bg-amber-600 transition-colors duration-300">
                  <Icon className="text-amber-600 group-hover:text-white transition-colors duration-300" size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA Section */}
        <div className="mt-20 bg-gray-900 rounded-sm p-12 text-center">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Ready to Start Your Project?
          </h3>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Let's discuss how we can bring your vision to life with our expert fit-out services
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center bg-amber-600 hover:bg-amber-700 text-white px-8 py-4 rounded-sm font-semibold text-lg transition-all duration-300 hover:shadow-lg hover:shadow-amber-600/30"
          >
            Contact Us Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
